const  sfloaterButton = document.createElement("button");
sfloaterButton.id = "clickonme";
sfloaterButton.onclick = function () {
  document.getElementById('popupgame').src = "https://cheveuxluxurypuzzle.wiplify.com";
  document.getElementById('popupframe').style.display= "block";
  document.getElementById('popupframeover').style.display= "block";

};
document.body.appendChild(sfloaterButton);

const  sfloaterImageButton = document.createElement("img");
sfloaterImageButton.src = "https://res.cloudinary.com/shulgirit/image/upload/v1652269121/wiply/Clients/cheveuxluxury/Asset_6_72x_ve0leu.png";
document.getElementById("clickonme").appendChild(sfloaterImageButton);

const sfloaterWrapper = document.createElement("div");
sfloaterWrapper.id = 'popupframeover';
sfloaterWrapper.onclick = function () {
  document.getElementById('popupgame').src = "";
  document.getElementById('popupframe').style.display= "none";
  document.getElementById('popupframeover').style.display= "none";
};
document.body.appendChild(sfloaterWrapper);

const spopupWrapper = document.createElement("div");
spopupWrapper.id = 'popupframe';
document.getElementById("popupframeover").appendChild(spopupWrapper);
  
const siframe = document.createElement("iframe");
siframe.id = "popupgame";
document.getElementById("popupframe").appendChild(siframe);

const popupClose = document.createElement("button");
popupClose.id = "popupXbutton";
popupClose.innerText = "X";
popupClose.onclick = function () {
  document.getElementById('popupgame').src = "";
  document.getElementById('popupframe').style.display= "none";
  document.getElementById('popupframeover').style.display= "none";
  
};
document.getElementById("popupframe").appendChild(popupClose);